import { render, staticRenderFns } from "./CadastrarMonitoramentoAgricolaParaguai.vue?vue&type=template&id=28f2ccb2&scoped=true&lang=pug"
import script from "./CadastrarMonitoramentoAgricolaParaguai.vue?vue&type=script&lang=js"
export * from "./CadastrarMonitoramentoAgricolaParaguai.vue?vue&type=script&lang=js"
import style0 from "./CadastrarMonitoramentoAgricolaParaguai.vue?vue&type=style&index=0&id=28f2ccb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f2ccb2",
  null
  
)

export default component.exports